import {
  Box,
  Divider,
  Drawer,
  Group,
  Text,
  UnstyledButton,
} from '@mantine/core'
import { useFAB } from './useFAB'
import classes from './AnchorFAB.module.css'

export function FABMenu() {
  const { actions, isOpen, closeMenu } = useFAB()

  // Split actions: regular and primary (shown after divider)
  const regularActions = actions.filter((a) => !a.primary)
  const primaryActions = actions.filter((a) => a.primary)

  function handleActionPress(action: typeof actions[0]) {
    if (action.disabled) return
    closeMenu()
    action.onPress()
  }

  return (
    <Drawer
      opened={isOpen}
      onClose={closeMenu}
      position="bottom"
      size="auto"
      title={null}
      withCloseButton={false}
      lockScroll={false}
      styles={{
        content: {
          borderTopLeftRadius: 'var(--mantine-radius-lg)',
          borderTopRightRadius: 'var(--mantine-radius-lg)',
        },
        body: {
          padding: 0,
        },
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.2)',
        },
      }}
    >
      {/* Drag handle */}
      <Group justify="center" py="xs">
        <Box
          w={40}
          h={4}
          bg="gray.4"
          style={{ borderRadius: 'var(--mantine-radius-full)' }}
        />
      </Group>

      {/* Regular actions */}
      <Box px="md" pb={primaryActions.length > 0 ? 0 : 'md'}>
        {regularActions.map((action) => (
          <UnstyledButton
            key={action.id}
            onClick={() => handleActionPress(action)}
            disabled={action.disabled}
            className={classes.menuItem}
            data-disabled={action.disabled || undefined}
          >
            <Group gap="sm" wrap="nowrap">
              <action.icon size={18} />
              <Box style={{ flex: 1 }}>
                <Text size="sm">{action.label}</Text>
                {action.disabled && action.hint && (
                  <Text size="xs" c="dimmed">
                    {action.hint}
                  </Text>
                )}
              </Box>
              {action.badge && <Box className={classes.menuBadge} />}
            </Group>
          </UnstyledButton>
        ))}
      </Box>

      {/* Primary actions (after divider) */}
      {primaryActions.length > 0 && (
        <>
          <Divider my="xs" />
          <Box px="md" pb="md">
            {primaryActions.map((action) => (
              <UnstyledButton
                key={action.id}
                onClick={() => handleActionPress(action)}
                disabled={action.disabled}
                className={classes.menuItem}
                data-primary
              >
                <Group gap="sm" wrap="nowrap">
                  <action.icon size={18} />
                  <Text size="sm" fw={500} c="primary">
                    {action.label}
                  </Text>
                  {action.badge && <Box className={classes.menuBadge} />}
                </Group>
              </UnstyledButton>
            ))}
          </Box>
        </>
      )}
    </Drawer>
  )
}
